import * as Yup from "yup";

export const PartyValidation = Yup.object().shape({
  partyCode: Yup.string().required("Party Code is required"),
  partyName: Yup.string()
    .min(2, "Must be greater then 2 character")
    .required("Party Name is required"),
  address: Yup.string().nullable().min(2, "Must be greater then 2 character"),
  company: Yup.string().nullable().min(2, "Must be greater then 2 character"),
  city: Yup.string().nullable().min(3, "Must be greater then 2 character"),
  email: Yup.string().nullable().email("Please enter valid email"),
  mobileNumber: Yup.string()
    .nullable()
    .min(7, "Please enter valid number")
    .max(20, "Please enter valid number"),
  phoneNumber: Yup.string()
    .nullable()
    .min(7, "Please enter valid number")
    .max(20, "Please enter valid number"),
});
